// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__eseyY","label":"Category_label__xL27A","content":"Category_content__xRbxM","header":"Category_header__QQDWc","location":"Category_location__2adss"};